export type PlatformKind = 'web' | 'pwa' | 'tauri';

export function detectPlatform(): PlatformKind {
  const w = window as Window & { __TAURI_INTERNALS__?: unknown; __TAURI__?: unknown };
  if (w.__TAURI_INTERNALS__ || w.__TAURI__) return 'tauri';
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    ('standalone' in navigator && Boolean((navigator as Navigator & { standalone?: boolean }).standalone));
  if (isStandalone) return 'pwa';
  return 'web';
}

export function isTouchDevice(): boolean {
  return window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
}

export type LayoutMode = 'mobile' | 'tablet' | 'desktop' | 'desktop-compact';

export function getLayoutMode(width: number): LayoutMode {
  if (width < 768) return 'mobile';
  if (width < 1024) return 'tablet';
  if (width < 1280) return 'desktop-compact';
  return 'desktop';
}
